import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { Dashboard } from "@src/types/dashboards";

export interface PostDuplicateDashboardV2Result {
  success: boolean;
  data?: Dashboard;
  error?: string;
}

export const postDuplicateDashboardV2UseCase = async (
  dashboardId: string,
): Promise<PostDuplicateDashboardV2Result> => {
  try {
    const namespace = store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.postDuplicateDashboardV2(
      namespace,
      dashboardId,
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to duplicate dashboard").message,
    };
  }
};
